import { defineRule } from '../rule.js';

/** H: a channel has neither an existing source item nor a source text nor a patch. */
export const channelWithoutSource = defineRule(
  'channel-without-source',
  'hint',
  { en: 'Channel without source', de: 'Kanal ohne Quelle' },
  (data, emit) =>
    Object.values(data.channels)
      .filter(
        (ch) =>
          (ch.sourceItemId === undefined || data.items[ch.sourceItemId] === undefined) &&
          !ch.sourceText &&
          !ch.patch,
      )
      .map((ch) => emit([ch.id], { number: ch.number, name: ch.name })),
);
